<div class="verification-code-page">
    <div class="teaser" disable-empty>
        <h2 i18n="@@landingpage.verification.teaser.headline" disable-empty format-text>null</h2>
        <h3 i18n="@@landingpage.verification.teaser.subheadline" disable-empty format-text>null</h3>
        <p i18n="@@landingpage.verification.teaser.text" disable-empty format-text>null</p>
    </div>
    <form [formGroup]="verificationCodeForm" (submit)="verification()">
        <h2 i18n="@@landingpage.verification.headline" class="" disable-empty format-text>Verification</h2>
        <validation [message]="verificationError"></validation>
        <div class="form-row">
            <label for="username" i18n="@@landingpage.verification.label.code">Verification code</label>
            <input test-id="verification.input.code" name="code" id="code" value="" type="text" formControlName="code" #code [class.error]="verificationCodeForm.controls.code.invalid && verificationCodeForm.controls.code.touched">
            <validation [control]="verificationCodeForm.controls.code">
                <validation-message type="required" i18n="@@landingpage.verification.message">You must enter the code.</validation-message>
            </validation>
        </div>
        <div class="button-row left-align">
            <button test-id="verification.button.signin" class="default white-spinner submit" type="submit" [attr.state]="confirmButtonState" i18n="@@landingpage.verification.button.send">Send</button>
            <span
            class="login-button-seperator"
            i18n="@@verification.button.seperator.text"
        >or</span>
        <a class="button default submit external-login"
            (click)="logout()"
            i18n="@@verification.logout.link"
            test-id="verification.link.logout"
        >Log out</a>
        </div>
    </form>
</div>